
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexWmunldgu009vWbxyWy2eee9wngjRL2zvN3I7IUljFaEMeta } from "/app/packages/competition/app/pages/[[season]]/index.vue?macro=true";
import { default as calendarSd4lepRBnSMEWjMi_GMIy0H3z15BZjOAERWotA9WBD0Meta } from "/app/packages/competition/app/pages/[[season]]/calendar.vue?macro=true";
import { default as index7C3I4PzbO7BtT8_q8QNXNVHarGogK0E3M2dcfOAounAMeta } from "/app/packages/competition/app/pages/[[season]]/cup/index.vue?macro=true";
import { default as indexgwueS6wTKrifd72f4OFBttZEhB1E3_ET1W3460RQ0EMMeta } from "/app/packages/competition/app/pages/[[season]]/help/index.vue?macro=true";
import { default as _180_45171vLbDy807G5BliKVJxBSrb781C9N8dPFw9YEbMgljkF0Meta } from "/app/packages/competition/app/pages/[[season]]/individual/180-171.vue?macro=true";
import { default as low_45visitsHfLhfdQGEqYOk3yCCPa_F_45G1bQ7t6otfbKPi9rooKLsMeta } from "/app/packages/competition/app/pages/[[season]]/individual/low-visits.vue?macro=true";
import { default as games_45playedWPTT3MTxqECkR0zSFC4Uk8qW7b2Tlv1AmjVQeljyMOAMeta } from "/app/packages/competition/app/pages/[[season]]/individual/games-played.vue?macro=true";
import { default as high_45checkoutsc_45nsClPHl2T59VCGPNrg8DG_45EiyzzBA1fcvEkysLzbAMeta } from "/app/packages/competition/app/pages/[[season]]/individual/high-checkouts.vue?macro=true";
import { default as individualDPIqxwYxQMzOQ9_45khp7RCPVd5h3SE1RxpqTW6_45PW42kMeta } from "/app/packages/competition/app/pages/[[season]]/individual.vue?macro=true";
import { default as indexb6tRCqCndp_45zvk3B0DPRdAwjZcuWW_450elDVT91oec2wMeta } from "/app/packages/competition/app/pages/[[season]]/news/index.vue?macro=true";
import { default as standings7Y3b3CjqAC2LB8nt9oJCTPFNBfFJ4x9j0NsvheNajusMeta } from "/app/packages/competition/app/pages/[[season]]/cup/[group]/standings.vue?macro=true";
import { default as individual_45standingsgy9qbx7Oeukfcc_WSQJHmKKXgCWbyA_xWVv01nXlxWsMeta } from "/app/packages/competition/app/pages/[[season]]/cup/[group]/individual-standings.vue?macro=true";
import { default as _91group_93hni7QJqowDlEg_45Zwq0L5spC2OWw6svP4r9pxjRFiN4oMeta } from "/app/packages/competition/app/pages/[[season]]/cup/[group].vue?macro=true";
import { default as _91slug_93PUIfctLcQBxTRKhiqP_f_45CbwaA8wOhuzlQxBHDTwcJwMeta } from "/app/packages/competition/app/pages/[[season]]/news/[slug].vue?macro=true";
import { default as index3U0qX_BkoreWFsTnPTfJfrcys4RqTdc8NMeA92JaPh8Meta } from "/app/packages/competition/app/pages/[[season]]/groups/index.vue?macro=true";
import { default as standingsYa6T2STiPIzghCxZ8yKAHdsTPEqbzSFaIlXtWrbwXIIMeta } from "/app/packages/competition/app/pages/[[season]]/groups/[group]/standings.vue?macro=true";
import { default as indexjbWqhoeq13L_45kz06GYaF_45aiedAk1yufRpmh_U_45iMdD4Meta } from "/app/packages/competition/app/pages/[[season]]/groups/[group]/teams/index.vue?macro=true";
import { default as _91team_93_MFx6zNNnB3srL9NMmhoGSbnwhTytnqtXJ1cPOZwamoMeta } from "/app/packages/competition/app/pages/[[season]]/groups/[group]/teams/[team].vue?macro=true";
import { default as individual_45standingslkDrPJsyNbJ3MmS41BIrfwMFFZ2hUA4WPkP1vVcdencMeta } from "/app/packages/competition/app/pages/[[season]]/groups/[group]/individual-standings.vue?macro=true";
import { default as _91group_93s0QuzDZZx0tHypa9QTUhl6QyGbaxLREwNNLjMpF_4521AMeta } from "/app/packages/competition/app/pages/[[season]]/groups/[group].vue?macro=true";
import { default as indexZtX0_45Yh1mGzaa07hv8lfdcLW35wm4PyBVDqZ4XgQPcAMeta } from "/app/packages/competition/app/pages/[[season]]/documents/index.vue?macro=true";
import { default as _91match_936_YOxI7PbJYPBx419wnV0CnvZlW8PZ_xq0ybLIxqYBYMeta } from "/app/packages/competition/app/pages/[[season]]/matches/[match].vue?macro=true";
import { default as indexdh0km68LadzK4OWbq6NOFdAZji0iHDMsn3p25Vbt_45GsMeta } from "/app/packages/competition/app/pages/[[season]]/board-members/index.vue?macro=true";
export default [
  {
    name: "season",
    path: "/:season?",
    component: () => import("/app/packages/competition/app/pages/[[season]]/index.vue")
  },
  {
    name: "season-calendar",
    path: "/:season?/calendar",
    component: () => import("/app/packages/competition/app/pages/[[season]]/calendar.vue")
  },
  {
    name: "season-cup",
    path: "/:season?/cup",
    component: () => import("/app/packages/competition/app/pages/[[season]]/cup/index.vue")
  },
  {
    name: "season-help",
    path: "/:season?/help",
    component: () => import("/app/packages/competition/app/pages/[[season]]/help/index.vue")
  },
  {
    name: "season-individual",
    path: "/:season?/individual",
    component: () => import("/app/packages/competition/app/pages/[[season]]/individual.vue"),
    children: [
  {
    name: "season-individual-180-171",
    path: "180-171",
    component: () => import("/app/packages/competition/app/pages/[[season]]/individual/180-171.vue")
  },
  {
    name: "season-individual-low-visits",
    path: "low-visits",
    component: () => import("/app/packages/competition/app/pages/[[season]]/individual/low-visits.vue")
  },
  {
    name: "season-individual-games-played",
    path: "games-played",
    component: () => import("/app/packages/competition/app/pages/[[season]]/individual/games-played.vue")
  },
  {
    name: "season-individual-high-checkouts",
    path: "high-checkouts",
    component: () => import("/app/packages/competition/app/pages/[[season]]/individual/high-checkouts.vue")
  }
]
  },
  {
    name: "season-news",
    path: "/:season?/news",
    component: () => import("/app/packages/competition/app/pages/[[season]]/news/index.vue")
  },
  {
    name: "season-cup-group",
    path: "/:season?/cup/:group()",
    component: () => import("/app/packages/competition/app/pages/[[season]]/cup/[group].vue"),
    children: [
  {
    name: "season-cup-group-standings",
    path: "standings",
    component: () => import("/app/packages/competition/app/pages/[[season]]/cup/[group]/standings.vue")
  },
  {
    name: "season-cup-group-individual-standings",
    path: "individual-standings",
    component: () => import("/app/packages/competition/app/pages/[[season]]/cup/[group]/individual-standings.vue")
  }
]
  },
  {
    name: "season-news-slug",
    path: "/:season?/news/:slug()",
    component: () => import("/app/packages/competition/app/pages/[[season]]/news/[slug].vue")
  },
  {
    name: "season-groups",
    path: "/:season?/groups",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/index.vue")
  },
  {
    name: "season-groups-group",
    path: "/:season?/groups/:group()",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/[group].vue"),
    children: [
  {
    name: "season-groups-group-standings",
    path: "standings",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/[group]/standings.vue")
  },
  {
    name: "season-groups-group-teams",
    path: "teams",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/[group]/teams/index.vue")
  },
  {
    name: "season-groups-group-teams-team",
    path: "teams/:team()",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/[group]/teams/[team].vue")
  },
  {
    name: "season-groups-group-individual-standings",
    path: "individual-standings",
    component: () => import("/app/packages/competition/app/pages/[[season]]/groups/[group]/individual-standings.vue")
  }
]
  },
  {
    name: "season-documents",
    path: "/:season?/documents",
    component: () => import("/app/packages/competition/app/pages/[[season]]/documents/index.vue")
  },
  {
    name: "season-matches-match",
    path: "/:season?/matches/:match()",
    component: () => import("/app/packages/competition/app/pages/[[season]]/matches/[match].vue")
  },
  {
    name: "season-board-members",
    path: "/:season?/board-members",
    component: () => import("/app/packages/competition/app/pages/[[season]]/board-members/index.vue")
  }
]